import LockIcon from '@mui/icons-material/Lock';
import {Grid, Typography} from '@mui/material';

import {Banner} from '../Banner';

import LightBanner from '../../../assets/locked-banner-light.png';

interface Props {
  text: string;
}

export const ScreeningModuleBanner = ({text}: Props) => {
  return (
    <Banner imageUrl={LightBanner}>
      <Grid container flexDirection='column' justifyContent='center' alignItems='center' padding='40px' gap='20px'>
        <Typography variant='h2' textAlign={'center'}>
          {text}
        </Typography>
        <LockIcon sx={{fontSize: 40}} />
      </Grid>
    </Banner>
  );
};
